<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">{{ $tc("itemcostprice") }}</div>
      </div>
      <div v-if="$can('create', 'Itemcostprice')">
        <b-button variant="default" to="add-itemcostprice" class="btn-blue">{{
          $tc("add")
        }}</b-button>
      </div>
    </div>
    <br />

    <div
      v-if="itemcostpricelist.length > 0"
      class="d-flex justify-content-between align-items-center my-3"
    >
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <div class="mx-2">
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              Viewing&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp;
              <strong>{{ rows }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>
    </div>

    <table class="list-view-table">
      <thead>
        <tr>
          <th class="text-left" style="width: 150px">
            <span class="pr-4">{{ $tc("status", 2) }}</span>
          </th>
          <th class="text-left" style="width: 360px">{{ $t("fnbitem") }}</th>
          <th class="text-left" style="width: 360px">
            {{ $tc("cinema", 1) }}
          </th>
          <th class="text-left">{{ $t("itemcostprice") }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(itemcost, itemIndex) in itemcostpricelist" :key="itemIndex">
          <td>
            <div class="d-flex align-items-center justify-content-start">
              <!-- <label class="ios-switch"> -->
              <b-form-checkbox
                :checked="itemcost.recipe_is_active == 'Y' ? true : false"
                type="checkbox"
                class="j-checkbox"
                disabled
              />
              <!-- <span class="switch-slider"></span>
    </label> -->

              <!-- Edit Icon with Tooltip -->
              <span
                v-if="$can('update', 'Itemcostprice')"
                v-b-tooltip="'Edit'"
                tabindex="0"
                @click="goToRoute('/fnb/edit-itemcostprice', itemcost)"
              >
                <span class="edit-pen cursor-pointer ml-2 blue-icon"></span>
              </span>

              <!-- View Icon with Tooltip -->
              <span
                v-b-tooltip="'View'"
                tabindex="0"
                @click="goToRoute('/fnb/view-itemcostprice', itemcost)"
              >
                <span class="icon-eye cursor-pointer ml-2 blue-icon"></span>
              </span>
            </div>
          </td>

          <td class="text-left">{{ itemcost.recipe_name }}</td>
          <td class="text-left">{{ itemcost.cine_name }}</td>
          <td class="text-left">
            {{ itemcost.curr_code }} {{ itemcost.itc_cost_price }}
          </td>
          <!-- <td>
            <div class="d-flex align-items-center justify-content-end">
              <label class="ios-switch">
                <input
                  :checked="itemcost.recipe_is_active == 'Y' ? true :false"
                  type="checkbox"
                  class="ios-checkbox"
                  disabled
                />
                <span class="switch-slider"></span>
              </label>

              <b-dropdown right variant="edit" class="ml-4">
                <b-dropdown-item @click="goToRoute('/fnb/edit-itemcostprice',itemcost)">
                  <span class="edit-pen"></span>
                  {{ $t('edit') }}
                </b-dropdown-item>
                <b-dropdown-item @click="goToRoute('/fnb/view-itemcostprice',itemcost)">
                  <span class="icon-eye mr-1"></span>
                  {{ $t('view') }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </td> -->
        </tr>
      </tbody>
      <tbody class="text-center" v-if="itemcostpricelist.length == 0">
        <td colspan="3">
          <h5>No Records Found.</h5>
        </td>
      </tbody>
    </table>

    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
  import MasterService from "@/services/MasterService";
  import CinemasService from "@/services/CinemasService";
  import PosFnbService from "@/services/PosFnbService";

  export default {
    data() {
      return {
        perPage: 10,
        currentPage: 1,
        rows: 0,
        selectedvalue: "10",
        itemcostpricelist: [],
      };
    },
    beforeMount() {
      this.getviewingnumber();
      this.getItemCostPriceList();
    },
    methods: {
      getviewingnumber() {
        this.viewingnumbers = [
          { name: "All", id: 1 },
          { name: "10", id: 2 },
          { name: "20", id: 3 },
          { name: "30", id: 3 },
          { name: "40", id: 4 },
          { name: "50", id: 5 },
        ];
      },
      onDropDownChangeValue(event) {
        if (event == "All") {
          this.perPage = this.rows;
          this.selectedvalue = event;
          this.onChangePagination();
        } else {
          console.log("Numbers :", event);
          this.selectedvalue = event;
          this.perPage = event;
          console.log("perPage :", this.perPage);
          this.onChangePagination();
        }
      },

      /* eslint-disable */
      onChangePagination: function(event) {
        // console.log(event);
        if (event === undefined) {
          this.currentPage = 1;
          this.getItemCostPriceList();
        } else {
          this.currentPage = event;
          this.getItemCostPriceList();
        }
      },

      getItemCostPriceList() {
        let payload = {
          limit: this.perPage,
          currentPage: this.currentPage,
        };
        PosFnbService.GetItemCostPrice(payload)
          .then((response) => {
            const { data } = response;
            // console.log("data :", data);
            if (data && data.status) {
              if (data.Records.length > 0) {
                this.itemcostpricelist = data.Records;
                if (data.totalRows >= 10) {
                  this.rows = data.totalRows;
                } else {
                  this.rows = data.totalRows;
                  this.selectedvalue = data.totalRows;
                }
              } else {
                this.$toasted.show(data.message);
              }
            }
          })
          .catch(this._CatchError); //message
      },

      goToRoute: function(path, { itc_id }) {
        // console.log("itc_id :", itc_id);
        this.$router.push({
          path: path,
          query: {
            id: itc_id,
          },
        });
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/ItemCostPriceComponents/ItemCostPrice.vue